import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class GrupoMaquinaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerTodos(callback) {
        this.gqlclient.query({
            query: gql `
        {
          grupo_maquina {
            obtenerTodos {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  nombre
                  codigo
                  descripcion
                }
              }
            }
          }
        }
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.grupo_maquina.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
}
GrupoMaquinaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GrupoMaquinaService_Factory() { return new GrupoMaquinaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: GrupoMaquinaService, providedIn: "root" });
